import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from 'src/app/core/services/login.service';
import { ToastService } from 'src/app/core/toast.service';
import { CommonServicesForAllModules } from 'src/app/shared/common/service';
import { Tables, TABLE_FIELDS } from 'src/app/shared/enum/tables.enum';

@Component({
  selector: 'app-add-newsfeed-category',
  templateUrl: './add-newsfeed-category.component.html',
  styleUrls: ['./add-newsfeed-category.component.scss']
})
export class AddNewsfeedCategoryComponent implements OnInit {
  categoryForm: FormGroup;
  categoryId: string | null = null;
  communityId: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private router: Router,
    private commonService: CommonServicesForAllModules,
    public loginService: LoginService,
    private toast: ToastService
  ) {
    this.categoryForm = this.fb.group({
      category_name: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    // Get route params
    this.route.paramMap.subscribe(params => {
      this.categoryId = params.get('id');              
      this.communityId = params.get('communityId'); 
      
      if (this.categoryId) {   
        console.log("")
        this.loadCategoryDetails();
      }
    });
  }

  private loadCategoryDetails() {
  this.commonService.GetById(Tables.NewsfeedCategories, this.categoryId, TABLE_FIELDS.NewsfeedCategories)
    .subscribe({
      next: (data: any) => {
        if (data) {
          this.categoryForm.patchValue({ category_name: data.category_name });
          this.communityId = data.community_id || null;
        }
      },
      error: (error) => {
        console.error('Error loading category:', error);
      }
    });
}


  onSubmit(): void {
    if (this.categoryForm.invalid) {
      this.categoryForm.markAllAsTouched();
      return;
    }

    const loginData = this.loginService.getLoginData();
    if (!loginData) return;

    const categoryData = {
      ...this.categoryForm.value,
      created_by: loginData.type,
      created_by_user_id: loginData.id,
      // Always send the current communityId if it exists
      community_id: this.communityId || null
    };

    const response = this.categoryId
      ? this.commonService.UpdateData(Tables.NewsfeedCategories, this.categoryId, categoryData)
      : this.commonService.InsertData(Tables.NewsfeedCategories, categoryData);

    response.then(() => {
      // Redirect after submit
      if (this.communityId) {
        // Community category
        this.router.navigate(['/profile/list-newsfeeds-catagory', this.communityId]);
      } else {
        // Normal category
        this.router.navigate(['/profile/list-newsfeeds']);
      }

      this.toast.openSnackBar(
        this.categoryId ? 'Category Updated successfully' : 'Category Added successfully'
      );
    }).catch(error => console.error(error));
  }


  onCancel(): void {
    if (this.communityId && !this.categoryId) {
      this.router.navigate(['/profile/list-newsfeeds-catagory', this.communityId]);
    } else {
      this.router.navigate(['/profile/list-newsfeeds']);
    }
  }
}
